import { render } from "./UserScoreCards.vue?vue&type=template&id=7cce5035&scoped=true"
import script from "./UserScoreCards.vue?vue&type=script&lang=js"
export * from "./UserScoreCards.vue?vue&type=script&lang=js"

import "./UserScoreCards.vue?vue&type=style&index=0&id=7cce5035&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cce5035"]])

export default __exports__